import InvoiceCreditsHtml from './templates/invoice-credits.html';

export function InvoiceCreditsDirective () {
  return {
    controller: 'InvoiceCreditsCtrl',
    restrict: 'E',
    templateUrl: InvoiceCreditsHtml,
    scope: {
      credits: '=',
      invoice: '='
    }
  }
}